/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */
/**
 * [[include:styles/icons/README.md]]
 * @packageDocumentation
 * @module icons
 */
import angle_down from "./angle-down.svg.js";
import angle_left from "./angle-left.svg.js";
import angle_right from "./angle-right.svg.js";
import angle_up from "./angle-up.svg.js";
import bin from "./bin.svg.js";
import cancel from "./cancel.svg.js";
import center from "./center.svg.js";
import check from "./check.svg.js";
import chevron from "./chevron.svg.js";
import dots from "./dots.svg.js";
import eye from "./eye.svg.js";
import file from "./file.svg.js";
import folder from "./folder.svg.js";
import info_circle from "./info-circle.svg.js";
import left from "./left.svg.js";
import lock from "./lock.svg.js";
import ok from "./ok.svg.js";
import pencil from "./pencil.svg.js";
import plus from "./plus.svg.js";
import resize_handler from "./resize-handler.svg.js";
import right from "./right.svg.js";
import save from "./save.svg.js";
import settings from "./settings.svg.js";
import unlock from "./unlock.svg.js";
import update from "./update.svg.js";
import upload from "./upload.svg.js";
import valign from "./valign.svg.js";
export { angle_down, angle_left, angle_right, angle_up, bin, cancel, center, check, chevron, dots, eye, file, folder, info_circle, left, lock, ok, pencil, plus, resize_handler, right, save, settings, unlock, update, upload, valign };
